module.exports = __webpack_public_path__ + "static/media/unipay.62af71e3.png";